import React from 'react';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '400px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
});

class AlertDialog extends React.Component {
  static propTypes = {};
  render() {
    const { cancelText, children, classes, onCancel, open, title } = this.props;

    return (
      <Dialog classes={{ root: classes.root, paper: classes.rootPaper }} open={open}>
        <h2 className={classes.title} id="confirm-title">
          {title}
        </h2>
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ root: classes.actionsRoot, action: classes.buttonAction }}>
          <Button onClick={onCancel || null} noMaxWidth={true} styleType={'secondary'}>
            {cancelText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default styled(AlertDialog)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Dialog/AlertDialogBase.js